import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { UpdateEmailEntryResponse } from './config';
import { emailEntryKeys } from './getEmailEntry';

import { isResponseError } from '../../../../api/config';
import { entryActionCustomValidateOptions } from '../../../../api/inbox';

// const url = `${PREFIX_URL}/v01/inbox`;
const url = `${PREFIX_URL}/inbox-threads/:inboxEntryId/emails/:emailId`;

export type DeleteEmailDTO = {
  projectId: string;
  inboxEntryId: number;
  emailId: number;
  trash: boolean;
};
export const deleteEmail = ({
  projectId,
  inboxEntryId,
  emailId,
  trash,
}: DeleteEmailDTO): Promise<UpdateEmailEntryResponse> => {
  return axios.put(
    generateRoutePath(url, { projectId, inboxEntryId, emailId }),
    {
      trash,
    },
    {
      ...entryActionCustomValidateOptions,
    }
  );
};

type DeleteEmailOptions = {
  projectId: string;
  inboxEntryId: number;
  config?: MutationConfig<typeof deleteEmail>;
};

export const useMarkDeleteEmail = ({ projectId, inboxEntryId, config }: DeleteEmailOptions) => {
  return useMutation({
    onSuccess: (data) => {
      if (isResponseError(data)) {
        return;
      }

      const newInboxEntry = data.data['inbox-entry'];

      queryClient.invalidateQueries([
        ...emailEntryKeys.detail({ emailId: data.data['inbox-email'].id, inboxEntryId, projectId }),
      ]);

      // We depend on socket update now
      // if (newInboxEntry.thread['total-emails-count'] < 1) {
      //   queryClient.invalidateQueries([...inboxEntriesKeys.lists({ projectId })]);
      // } else {
      //   queryClient.invalidateQueries([...emailEntriesKeys.lists({ projectId, inboxEntryId })]);
      // }
    },
    ...config,
    mutationFn: deleteEmail,
  });
};
